import React, { useCallback } from 'react';

import { isNull } from 'lodash';
import Checkbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';

const CheckboxUpward = (props) => {
   return (
      <Checkbox
         checked={props.value}
         onChange={props.handleChange}
         size='small'
         disableRipple
         inputProps={{
            onBlur: props.handleBlur,
            checked: props.value,
         }}
         className='p-0'
         disabled={props.isDisabled}
      />
   );
};

Checkbox.propTypes = {
   value: PropTypes.bool,
   handleChange: PropTypes.func,
   isDisabled: PropTypes.bool,
};

Checkbox.defaultProps = {
   value: false,
};

const withCheckboxFormik = (CheckboxComponent) => {
   // Props onChange, onBlur, name
   const WrappedComponent = (props) => {
      const handleChange = useCallback((event) => {
         props.form.setFieldValue(props.field.name, event?.target?.checked);
         if (props.onChange) {
            props.onChange(event?.target?.checked);
         }
      }, []);

      const handleBlur = useCallback(() => {
         props.form.setFieldTouched(props.field.name, true);
      }, []);

      const value = isNull(props.value) ? !!(props.field.value) : !!(props.value);

      return (
         <CheckboxComponent
            name={props.field.name}
            value={value}
            handleChange={handleChange}
            handleBlur={handleBlur}
            isDisabled={props.isDisabled}
         />
      );
   };

   WrappedComponent.propTypes = {
      field: PropTypes.shape({
         name: PropTypes.string.isRequired,
         onChange: PropTypes.func.isRequired,
         onBlur: PropTypes.func.isRequired,
         value: PropTypes.bool,
      }).isRequired,
      form: PropTypes.shape({
         touched: PropTypes.object.isRequired,
         errors: PropTypes.object.isRequired,
      }).isRequired,
      onChange: PropTypes.func,
      isDisabled: PropTypes.bool,
      value: PropTypes.bool,
   };

   WrappedComponent.defaultProps = {
      onChange: null,
      value: null,
   };

   return WrappedComponent;
};

export default withCheckboxFormik(CheckboxUpward);
